import React, { useEffect, useRef, useState } from "react";
import * as api from "../../common/manipurCommon/API";
import * as func from "../../common/manipurCommon/FunctionCalls";
import Utils from "../../common/manipurCommon/Utils";
import { usePermissions } from "../../common/PermissionContext";
import { Link, useLocation } from "react-router-dom";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import Select from "react-select";
import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";
import { Button, Modal, ModalBody, ModalHeader, ModalFooter, ModalTitle } from "react-bootstrap";
import Swal from "sweetalert2";

const WLRecord = () => {

    const [worldRecordData, setWorldRecordData] = useState<any[]>([]);
    const [genderList, setGenderList] = useState<any[]>([]);
    const [weightClassList, setWeightClassList] = useState<any[]>([]);
    const [athleteList, setAthleteList] = useState<any[]>([]);
    const [athleteName, setAthleteName] = useState("");
    const [weightClass, setWeightClass] = useState("");
    const [recordCategory, setRecordCategory] = useState("");
    const [recordValue, setRecordValue] = useState("");
    const [recordUnit, setRecordUnit] = useState("kg");
    const [dob, setDob] = useState("");
    const [nation, setNation] = useState("");
    const [eventDate, setEventDate] = useState("");
    const [eventPlace, setEventPlace] = useState("");
    const [gender, setGender] = useState("");
    const [searchInput, setSearchInput] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [showFields, setShowFields] = useState(false);

    const formRef = useRef(null);

    const { permissionsMap } = usePermissions();
    const location = useLocation();

    const currentPath = location.pathname;
    const currentPermissions = permissionsMap[currentPath] || [];

    const recordCtgryList = [{ catId: 1, catName: "Snatch" }, { catId: 2, catName: "C & J" }, { catId: 3, catName: "Total" }];

    useEffect(() => {
        async function fetchWorldRecord() {
            setIsLoading(true);
            const worldRecordResponse = await func.worldRecord(null);
            setWorldRecordData(Array.isArray(worldRecordResponse) ? worldRecordResponse : [])
            setIsLoading(false);
        }
        fetchWorldRecord();
    }, []);

    const filteredData = worldRecordData.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const customSelect = {
        control: (base) => ({
            ...base,
            // padding: '20px',
            borderRadius: '10px',
            background: '#FAFAFA',
            border: 'none',
            boxShadow: 'none', // prevents default blue border on focus
            minHeight: 'unset', // optional: removes default height if needed
        }),
        placeholder: (base) => ({
            ...base,
            color: '#aaa',
        }),
        singleValue: (base) => ({
            ...base,
            color: '#333',
        }),
        menu: (base) => ({
            ...base,
            zIndex: 9999,
        }),
    }

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const weightClassRender = (rowData) => {
        return <span>{rowData.weightClass}</span>;
    };

    const recordCategoryRender = (rowData) => {
        return <span>{rowData.recordCategory}</span>;
    };

    const recordValueRender = (rowData) => {
        return <span>{rowData.recordValue}</span>;
    };

    const recordUnitRender = (rowData) => {
        return <span>{rowData.recordUnit}</span>;
    };

    const athleteNameRender = (rowData) => {
        return <span>{rowData.athleteName}</span>;
    };

    const athleteDobRender = (rowData) => {
        return <span>{formatDate(rowData.athleteBorn)}</span>;
    };

    const athleteNationRender = (rowData) => {
        return <span>{rowData.athleteNation}</span>;
    };

    const eventDateRender = (rowData) => {
        return <span>{formatDate(rowData.eventDate)}</span>;
    };

    const eventPlaceRender = (rowData) => {
        return <span>{rowData.eventPlace}</span>;
    };

    const statusRender = (rowData) => {
        return <span>{(rowData.status == 1) ? "Active" : "Inactive"}</span>;
    };

    async function newWLRecord() {
        setIsEdit(false);
        const athltResponse = await func.externalCompAthletes(null);
        setAthleteList(Array.isArray(athltResponse) ? athltResponse : []);
        const ctgryResponse = await func.externalCompCategory(null);
        setGenderList(Array.isArray(ctgryResponse) ? ctgryResponse : [])
        const wghtResponse = await func.externalCompClass(null);
        setWeightClassList(Array.isArray(wghtResponse) ? wghtResponse : [])
        setOpenModal(true);
    }

    const athleteOptions = [
        {
            value: "World Standard",
            label: "World Standard"
        },
        ...athleteList.map(athlt => ({
            value: athlt.extComAthleteName,
            label: athlt.extComAthleteName
        }))
    ];

    const formatDate = (date) => {
        const dateObj = new Date(date);
        const day = String(dateObj.getDate()).padStart(2, '0');
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const year = dateObj.getFullYear();
        return `${day}-${month}-${year}`;
    };

    function handleSubmit(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            // Manually trigger native HTML5 validation message
            formRef.current.reportValidity();
        } else {
            const formData = new FormData();
            formData.append("athleteName", athleteName);
            formData.append("weightClass", weightClass);
            formData.append("recordCategory", recordCategory);
            formData.append("recordValue", recordValue);
            formData.append("recordUnit", recordUnit);
            formData.append("athleteBorn", dob);
            formData.append("athleteNation", nation);
            formData.append("eventDate", eventDate);
            formData.append("eventPlace", eventPlace);
            formData.append("genderCategory", gender);

            // formData.forEach((value, key) => {
            //     console.log(`${key}: ${value}`);
            // });

            const createRecord = api.WorldRecord;
            fetch(createRecord, {
                method: "POST",
                headers: {
                    "Authorization": 'Bearer ' + Utils.getAccessToken()
                },
                body: formData
            })
                .then((response) => response.json())
                .then((result) => {
                    if (result.error == false) {
                        Swal.fire({
                            title: 'Success',
                            text: result.message,
                            icon: 'success',
                            confirmButtonText: 'OK',
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        }).then((res) => {
                            if (res.isConfirmed) {
                                window.location.reload(); // 🔁 Reload only after OK is clicked
                            }
                        });
                    } else {
                        if (result.code == 401) {
                            Utils.logoutUser();
                        }
                        Swal.fire({
                            title: 'Error',
                            text: result.message,
                            icon: 'error',
                            confirmButtonText: 'OK',
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        }).then((res) => {
                            if (res.isConfirmed) {
                                window.location.reload(); // 🔁 Reload only after OK is clicked
                            }
                        });
                    }
                })
        }
    }

    return (
        <>
            {isLoading && (
                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="content container" style={{ maxWidth: "1500px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>Weightlifting Records</h4>
                                    {currentPermissions.includes("add") ?
                                        <Link
                                            to="#"
                                            className="btn"
                                            onClick={() => { newWLRecord() }}
                                            data-bs-toggle="tooltip"
                                            style={{ fontSize: "24px", padding: "0px" }}
                                            title="Create Weightlifting Record">
                                            <i className="feather-plus" />&nbsp;
                                        </Link>
                                        : null
                                    }
                                </div>
                            </div>
                            <div className="row col-lg-12 mb-10">
                                <div className="col-lg-12 col-sm-12 text-end dataTables_filter">
                                    <label>
                                        <input
                                            type="text"
                                            value={searchInput}
                                            onChange={(e) => setSearchInput(e.target.value)}
                                            style={{ height: "40px" }}
                                            placeholder="Search"
                                            className="form-control"
                                        />
                                    </label>
                                </div>
                            </div>
                            <div className="tab-content">
                                <div
                                    className="tab-pane fade show active"
                                    id="nav-Recent"
                                    role="tabpanel"
                                    aria-labelledby="nav-Recent-tab"
                                    tabIndex={0}
                                >
                                    <div className="table-responsive table-datatble">
                                        <DataTable
                                            className="table datatable"
                                            value={filteredData}
                                            paginator
                                            rows={10}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                            pageLinkSize={3}
                                        >
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="slNo"
                                                body={slNoRender}
                                                header="Sl &nbsp; No"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="athleteName"
                                                header="Athlete Name"
                                                body={athleteNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="weightClass"
                                                header="Weight Class"
                                                body={weightClassRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="recordCategory"
                                                header="Record Category"
                                                body={recordCategoryRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="recordValue"
                                                header="Record Value"
                                                body={recordValueRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="recordUnit"
                                                header="Record Unit"
                                                body={recordUnitRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="athleteBorn"
                                                header="Date of Birth"
                                                body={athleteDobRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="athleteNation"
                                                header="Nation"
                                                body={athleteNationRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="eventDate"
                                                header="Event Date"
                                                body={eventDateRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="eventPlace"
                                                header="Event Place"
                                                body={eventPlaceRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="status"
                                                header="Status"
                                                body={statusRender}
                                                className="table-inset-btn"
                                            ></Column>
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal
                size="xl"
                centered
                show={openModal}
                onHide={() => setOpenModal(false)}
            >
                <ModalHeader>
                    <ModalTitle>
                        <h4 className="mb-0 upper-case">{isEdit ? "Edit " : "Add "} Weightlifting Record</h4>
                    </ModalTitle>
                    <Button
                        variant=""
                        className="btn-close"
                        onClick={() => setOpenModal(false)}
                    ></Button>
                </ModalHeader>
                <ModalBody>
                    <form ref={formRef}>
                        <div className="row">
                            <div className="col-lg-3 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Athlete</label>
                                    <Select
                                        // value={athleteList.find(athlt => athlt.extComAthleteName === athleteName) ? {
                                        //     value: athleteName,
                                        //     label: athleteList.find(athlt => athlt.extComAthleteName === athleteName).extComAthleteName
                                        // } : null}
                                        // value={athleteName === "World Standard" ? {
                                        //     value: "World Standard",
                                        //     label: "World Standard"
                                        // }
                                        //     : athleteList.find(athlt => athlt.extComAthleteName === athleteName) ? {
                                        //         value: athleteName,
                                        //         label: athleteName
                                        //     } : null}
                                        value={
                                            athleteOptions.find(
                                                option => option.value === athleteName
                                            ) || null
                                        }
                                        onChange={(e) => {
                                            setAthleteName(e.value || "World Standard");
                                            { (e.value === "World Standard") ? setShowFields(false) : setShowFields(true) }
                                        }}
                                        styles={customSelect}
                                        required
                                        // options={athleteList.map(athlt => ({
                                        //     value: athlt.extComAthleteName,
                                        //     label: athlt.extComAthleteName
                                        // }))}
                                        options={athleteOptions}
                                    >
                                    </Select>
                                </div>
                            </div>
                            {showFields && (
                                <>
                                    <div className="col-lg-3">
                                        <div className="input-space">
                                            <label className="form-label">Date of Birth</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                name="dob"
                                                value={dob}
                                                required
                                                onChange={(e) => { setDob(e.target.value) }}
                                                placeholder="Enter Date of Birth" />
                                        </div>
                                    </div>
                                    <div className="col-lg-3">
                                        <div className="input-space">
                                            <label className="form-label">Nation</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="nation"
                                                value={nation}
                                                onChange={(e) => { setNation(e.target.value) }}
                                                placeholder="Enter Nation" />
                                        </div>
                                    </div>
                                </>
                            )}
                            <div className="col-lg-3">
                                <div className="input-space">
                                    <label className="form-label">Gender Category</label>
                                    <Select
                                        value={genderList.find(gndr => gndr.extcomCategoryId  === gender) ? {
                                            value: gender,
                                            label: genderList.find(gndr => gndr.extcomCategoryId  === gender).extComCategoryName
                                        } : null}
                                        onChange={(e) => {
                                            setGender(e.value);
                                        }}
                                        styles={customSelect}
                                        required
                                        options={genderList.map(gndr => ({
                                            value: gndr.extcomCategoryId ,
                                            label: gndr.extComCategoryName
                                        }))}>
                                    </Select>
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <div className="input-space">
                                    <label className="form-label">Weight Class</label>
                                    <Select
                                        value={weightClassList.find(wght => wght.extClassName === weightClass) ? {
                                            value: weightClass,
                                            label: weightClassList.find(wght => wght.extClassName === weightClass).extClassName
                                        } : null}
                                        onChange={(e) => {
                                            setWeightClass(e.value);
                                        }}
                                        styles={customSelect}
                                        required
                                        options={weightClassList.map(wght => ({
                                            value: wght.extClassName,
                                            label: wght.extClassName
                                        }))}>
                                    </Select>
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <div className="input-space">
                                    <label className="form-label">Record Category</label>
                                    <Select
                                        value={recordCtgryList.find(ctgry => ctgry.catName === recordCategory) ? {
                                            value: recordCategory,
                                            label: recordCtgryList.find(ctgry => ctgry.catName === recordCategory)?.catName ?? ''
                                        } : null}
                                        onChange={(e) => {
                                            setRecordCategory(e.value);
                                        }}
                                        styles={customSelect}
                                        required
                                        options={recordCtgryList.map(ctgry => ({
                                            value: ctgry.catName,
                                            label: ctgry.catName
                                        }))}>
                                    </Select>
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <div className="input-space">
                                    <label className="form-label">Record Value</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        name="recordValue"
                                        value={recordValue}
                                        min={1}
                                        max={999}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (value === "" || (Number(value) >= 1 && Number(value) <= 999)) {
                                                setRecordValue(value);
                                            }
                                        }}
                                        placeholder="Enter Record Value" />
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <div className="input-space">
                                    <label className="form-label">Event Date</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        name="eventDate"
                                        value={eventDate}
                                        onChange={(e) => { setEventDate(e.target.value) }}
                                        placeholder="Enter Event Date" />
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <div className="input-space">
                                    <label className="form-label">Event Place</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="eventPlace"
                                        value={eventPlace}
                                        onChange={(e) => { setEventPlace(e.target.value) }}
                                        placeholder="Enter Event Place" />
                                </div>
                            </div>
                        </div>
                        <ModalFooter>
                            <Button
                                className="btn-primary text-uppercase"
                                variant="success"
                                type="submit"
                                onClick={handleSubmit}
                            >
                                <b><i className="fas fa-save" />Save</b>
                            </Button>
                        </ModalFooter>
                    </form>
                </ModalBody>
            </Modal>
        </>
    );
}

export default WLRecord;